import React, { useState } from 'react';
import { IconLocation } from '../icons';
import { PHONE } from '../../lib/contants';
import {
  Dialog,
  DialogContent,
  DialogTrigger,
} from 'components/ui/dialog/dialog';
import { Button } from 'components/ui/primitives/button/button';
import { Logo } from "../ui/logo/logo";
import { useConsentStore } from "../../lib/store/consent-store";
import { DialogForm } from "../ui/dialog-form/dialog-form";

const Container = ({ children }: { children: React.ReactNode }) => {
  return <div className="max-w-[1386px] w-full mx-auto">{children}</div>;
};

const Header = () => {

  const menuList = [
    {
      name: 'Планировки',
      link: '#flats',
    },
    {
      name: 'Отделка',
      link: '#finishing',
    },
    {
      name: 'Преимущества',
      link: '#advantages',
    },
    {
      name: 'Способы проезда',
      link: '#routes',
    },
    {
      name: 'Контакты',
      link: '#contacts',
    },
  ];

  const consent = useConsentStore(state => state.consent);
  const updateConsent = useConsentStore(state => state.updateConsent);

  return (
    <header className="pt-5 pb-3 font-open-sans">
      <Container>
        <div className="flex items-center justify-between screen-1410:px-4">
          <div className="flex items-center gap-10">
            <a
              href="/"
              className="screen-1220:px-[10px]"
            >
              <Logo />
            </a>
            <div className="flex items-center gap-2 font-semibold text-plt-black screen-1220:hidden">
              <IconLocation />
              <p>Новая Москва</p>
            </div>
          </div>
          <div className="screen-1220:hidden">
            <nav>
              <div className="flex items-start text-xs leading-[120%] gap-5 ms-2 hidden">
                <div>31.12.25 г. — 02.01.26 г.:<br /><b>выходные дни.</b></div>
                <div>03.01.26 г. — 11.01.26 г.: <br /><b>ежедневно с 10:00 до 19:00.</b></div>
                <div>С 12.01.26 г.<br /><b>ОП работают в обычном режиме.</b></div>
              </div>
              <ul className="flex gap-5 font-semibold mt-5">
                {menuList.map((item, index) => (
                  <li key={index.toString() + item.name}>
                    <a
                      href={item.link}
                      className="px-2 py-1.5 text-plt-black rounded-full hover:bg-plt-secondary/50"
                    >
                      {item.name}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          </div>
          <div className="flex flex-col items-center gap-2">
            <a
              href={`tel:${PHONE.replaceAll('(', '')
                .replaceAll(')', '')
                .replaceAll('-', '')
                .replaceAll('+', '')
                .replaceAll(' ', '')
                }`}
              className="font-semibold text-xl screen-1220:hidden roistat_kr"
            >
              {PHONE}
            </a>
            <DialogForm title={'Заказать звонок'} celtype='getCall'>
              <Button
                className="bg-plt-secondary h-[52px] px-[22px] py-4 rounded-xl text-plt-white font-semibold screen-1220:px-[15px] screen-1220:h-8 screen-1220:rounded-[5px]">
                Заказать звонок
              </Button>
            </DialogForm>
          </div>
          <div className="hidden screen-1220:block">
            <Dialog>
              <DialogTrigger asChild>
                <button className="size-[15px] flex flex-col items-end justify-between">
                  <span className="block w-[15px] h-0.5 bg-plt-black" />
                  <span className="block w-[10px] h-0.5 bg-plt-black" />
                  <span className="block w-[15px] h-0.5 bg-plt-black" />
                </button>
              </DialogTrigger>
              <DialogContent className="border-none bg-plt-white rounded-[20px] w-[280px]">
                <div className="py-10">
                  <div className="flex flex-col items-center text-xs leading-[120%] gap-5 text-center mb-5 hidden">
                    <div>31.12.25 г. — 02.01.26 г.:<br /><b>выходные дни.</b></div>
                    <div>03.01.26 г. — 11.01.26 г.: <br /><b>ежедневно с 10:00 до 19:00.</b></div>
                    <div>С 12.01.26 г.<br /><b>ОП работают в обычном режиме.</b></div>
                  </div>
                  <ul className="flex flex-col gap-5 font-semibold items-center">
                    {menuList.map((item, index) => (
                      <li key={item.name}>
                        <a
                          href={item.link}
                          className="px-2 py-1.5 text-plt-black rounded-full hover:bg-plt-secondary/50"
                        >
                          {item.name}
                        </a>
                      </li>
                    ))}
                  </ul>
                </div>
              </DialogContent>
            </Dialog>
          </div>
        </div>
      </Container>
    </header>
  );
};

const Footer = () => {
  return (
    <footer className="bg-plt-black text-plt-white font-open-sans px-[33px]">
      <Layout.Container>
        <div className="flex justify-between gap-20 py-10 screen-900:grid screen-900:gap-5">
          <div className="shrink-0 font-semibold text-sm leading-[120%] screen-900:text-center flex flex-col gap-10">
            <div>
              <p>© 2025 «ЖК Крекшино Парк»</p>
              <p>Все права защищены.</p>
            </div>
            <div>
              <a target='_blank' className='text-white underline hover:text-gray-200' href="/politics_work.pdf">Политика
                в области охраны труда</a>
            </div>
          </div>
          <p className="font-semibold text-sm leading-[120%] screen-900:text-center">
            Продолжая использовать наш сайт и отправляя любую форму на сайте, Вы
            даете согласие на обработку файлов Cookies и других пользовательских
            данных, в соответствии с политикой конфиденциальности данного сайта,
            а также соглашаетесь на получение рассылки на электронную почту,
            указанную в заявке.Запретить обработку Cookies можно в настройках
            Вашего браузера. Любая информация, представленная на данном сайте,
            носит исключительно информационный характер и ни при каких условиях
            не является публичной офертой, определяемой положениями статьи 437
            ГК РФ. С проектной декларацией можно ознакомиться на <a
              href="https://наш.дом.рф/%D1%81%D0%B5%D1%80%D0%B2%D0%B8%D1%81%D1%8B/%D0%BA%D0%B0%D1%82%D0%B0%D0%BB%D0%BE%D0%B3-%D0%BD%D0%BE%D0%B2%D0%BE%D1%81%D1%82%D1%80%D0%BE%D0%B5%D0%BA/%D0%BE%D0%B1%D1%8A%D0%B5%D0%BA%D1%82/65370">наш.дом.рф</a>.
            Визуализация проекта предварительная,
            возможны изменения.
          </p>
          <div className="shrink-0 screen-900:text-center">
            <a href="https://leadactiv.ru/">
              <p className="font-semibold text-sm leading-[120%]">
                Разработка и лидогенерация:
              </p>
              <img
                className="mt-5 screen-900:mx-auto"
                src="/assets/images/png/leadactiv-logo.png"
                alt="leadactiv logo"
              />
            </a>
          </div>
        </div>
      </Layout.Container>
    </footer>
  );
};

export const Layout = {
  Container,
  Header,
  Footer,
};
